import React from 'react';
import PropTypes from 'prop-types';
import { renderToString } from 'react-dom/server';
import { spring, StaggeredMotion } from 'react-motion';

import { Image, SharingPopup } from 'C4';

const VideoCollection = (props) => {
  const { chapter } = props;
  const chapterName = chapter[0].chapter.chapterTitle;
  const chapterNr = chapter[0].chapter.chapterNumber;

  // Dynamically Create enough animation starting values
  const startingValues = [];
  Object.keys(chapter).map(() => {
    const newObj = {};
    newObj.pos = 0;
    return startingValues.push(newObj);
  });

  const fancyOptions = {
    infobar: true,
    thumbs: {
      autoStart: true,
      axis: 'y',
    },
    buttons: ['thumbs', 'share', 'download', 'close'],
    share: {
      tpl: renderToString(<SharingPopup url={window.location.href} />),
    },
    caption: chapterName,
  };

  return (
    <div className="videoGrid__Container">
      <div className="videoGrid__Container--title">
        <h3>{chapterName}</h3>
        <h5>{`Chapter ${chapterNr}`}</h5>
      </div>
      <StaggeredMotion
        defaultStyles={startingValues}
        styles={prevInterpolatedStyles => prevInterpolatedStyles.map((_, i) => (i === 0
          ? { pos: spring(1, { stiffness: 320, damping: 28 }) }
          : { pos: spring(prevInterpolatedStyles[i - 1].pos, { stiffness: 320, damping: 28 }) }))}
      >
        {styles => (
          <div className="videoGrid__Grid">
            {Object.values(chapter).map((item, index) => {
              const {
                linkJW,
                thumbnail,
                title,
                url,
              } = item;
              return (
                <div className="videoGrid_Holder">
                  <div className="videoGrid_Card" key={linkJW} style={{ opacity: `${styles[index].pos}` }}>
                    <Image
                      key={linkJW}
                      src={thumbnail || 'https://via.placeholder.com/350x250?text=Placeholder%20Thumbnail'}
                      gradient
                      onLoad={() => { this.setState({ loading: false }); }}
                      href={url}
                      fancybox={linkJW}
                      options={fancyOptions}
                      caption={title}
                    />
                  </div>
                  <div className="title">{title}</div>
                </div>
              );
            })}
          </div>
        )}
      </StaggeredMotion>
    </div>
  );
};

export default VideoCollection;

VideoCollection.propTypes = {
  chapter: PropTypes.arrayOf.isRequired,
};
